import cookie from "react-cookies";
import axios from 'axios';
import {AuthHeader} from "../helper/auth.token"
import { presentAppKey } from '../component/neoviewer/apps/app_keys'

export const INIT_STATE = "INIT_STATE";
export const UPDATE_STATE = "UPDATE_STATE";
export const START_PRESENTING = "START_PRESENTING";
export const CLEAR_PRESENTING_STATUS = "CLEAR_PRESENTING_STATE";
export const CLEAR_FOLLOWING_STATUS = "CLEAR_FOLLOWING_STATE";
export const UPDATE_APP_CLOSED_STATE = "UPDATE_APP_CLOSED_STATE";
export const UPDATE_APP_POSITION = "UPDATE_APP_POSITION";
export const UPDATE_APP_CLICK_TIME = "UPDATE_APP_CLICK_TIME";

export const resetMapParams = (currentState) => dispatch => {
    
    let newState = {
        ...currentState,
        x: -1,
        y: -1,
        z: 0,
        r: 0
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}


export const clearPresentingStatus = () => dispatch => {
    dispatch({
        type: CLEAR_PRESENTING_STATUS
    })
}


export const clearFollowingStatus = () => dispatch => {
    dispatch({
        type: CLEAR_FOLLOWING_STATUS
    })
}


export const startPresenting = (currentState, code) => dispatch => {

    let newState = {
        ...currentState, 
        app_state: {
            ...currentState.app_state, 
            [presentAppKey.id]: {
                ...currentState.app_state[presentAppKey.id], 
                code: code
            }
        }
    }

    dispatch({
        type: START_PRESENTING, 
        urlState: newState
    })
}


export const updateMapParams = (currentState, x, y, z, r) => dispatch => {

    let newState = {
        ...currentState,
        x: x,
        y: y,
        z: z,
        r: r
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}


export const updateZoom = (currentState, z) => dispatch => {
    
    let newState = {
        ...currentState,
        z: z,
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}


export const updateGridShow = (currentState, showGrid) => dispatch => {
    
    let newState = {
        ...currentState, 
        showGrid: showGrid
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}


export const updateGridColor = (currentState, gridColor) => dispatch => {
    
    let newState = {
        ...currentState, 
        gridColor: gridColor
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}

export const updateAnnoColor = (currentState, annoColor) => dispatch => {
    
    let newState = {
        ...currentState, 
        annoColor: annoColor
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}


export const updateGridSize = (currentState, gridSize) => dispatch => {
    
    let newState = {
        ...currentState, 
        gridSize: gridSize
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}


export const updateGridWidth = (currentState, gridWidth) => dispatch => {
    
    let newState = {
        ...currentState, 
        gridWidth: gridWidth
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}


export const updateDigitalZoomStatus = (currentState, digitalZoomStatus) => dispatch => {

    let newState = {
        ...currentState,
        digitalZoomStatus: digitalZoomStatus
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}

export const updatePreviewColorStatus = (currentState, previewColor) => dispatch => {

    let newState = {
        ...currentState,
        previewColor: previewColor
    }

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}

export const updateAppClosedStatus = (appName, closed) => dispatch => {

    dispatch({
        type: UPDATE_APP_CLOSED_STATE, 
        appClosedStatus: closed, 
        appName: appName
    })
}

export const updateAppPosition = (appName, position, allAppsState) => dispatch => {

    dispatch({
        type: UPDATE_APP_POSITION, 
        appPosition: position, 
        appName: appName
    });
}

export const updateAppClickTime = (appName, allAppsState) => dispatch => {

    dispatch({
        type: UPDATE_APP_CLICK_TIME, 
        appName: appName
    });
}

export const updateUrlStateInReducer = (oldState) => dispatch => {
    var newState = urlParser(oldState);

    dispatch({
        type: UPDATE_STATE, 
        urlState: newState
    })
}

export const loadMorpheusSettings = () => dispatch => {
    let url = `/api/morpheussetting/` + cookie.load('morpheus_setting').id + `/`;
    axios.get(url , {headers: {Authorization : AuthHeader()}})
        .then(response => {
            if(response.status === 200){
                response.data.apps_initialised = true;
                dispatch({
                    type: INIT_STATE, 
                    urlState: response.data
                })
            }
            else{
                console.log(response);
            }
        })
        .catch(err => {
            console.log(err);
        })
}

export const urlParser = (parsedPartsOfUrl) => {
    try {
        var url = window.location.href.split('?')[1];
        if (url != undefined) {
            var partsOfUrl = url.split('&');
            partsOfUrl.map((part) => {
                var key = part.split('=')[0];
                var value = part.split('=')[1];
                if (key === 'x') {
                    parsedPartsOfUrl.x = parseFloat(value);
                } else if (key === 'y') {
                    parsedPartsOfUrl.y = parseFloat(value);
                } else if (key === 'z') {
                    parsedPartsOfUrl.z = parseInt(value, 10);
                } else if (key === 'r') {
                    parsedPartsOfUrl.r = parseFloat(value);
                } else if (key === 'digitalZoomStatus') {
                    parsedPartsOfUrl.digitalZoomStatus = value === 'true' ? true : false;
                } else if (key === 'presentCode') {
                    parsedPartsOfUrl.presentCode = parseInt(value);
                } 
            });
        }
    } catch (err) {
        console.log('Could not parse Url',window.location.href, err);
    }
    return parsedPartsOfUrl;
}